import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route: any = '/marketplaces';

const MarketplaceRoute: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('./Collections')),
    name: 'Collections',
};

export default MarketplaceRoute;
